import { getApps, initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, initializeFirestore, type Firestore } from 'firebase/firestore';
import { getFirebaseApp } from '@/lib/firebase';

const PROVISIONER_APP_NAME = 'finvox-provisioner';

export function getProvisionerApp(): FirebaseApp {
  const existing = getApps().find((app) => app.name === PROVISIONER_APP_NAME);
  if (existing) return existing;
  return initializeApp(getFirebaseApp().options, PROVISIONER_APP_NAME);
}

export function getProvisionerAuth(): Auth {
  return getAuth(getProvisionerApp());
}

export function getProvisionerFirestore(): Firestore {
  const app = getProvisionerApp();
  try {
    return getFirestore(app);
  } catch {
    return initializeFirestore(app, { experimentalAutoDetectLongPolling: true });
  }
}
